export default "__VITE_ASSET__hOyJsx21__"